import React from 'react';
import PropTypes from 'prop-types';

const btnCls = 'cmn-filter__footerBtn ui-btn';

const PopoverFooter = ({ cancelFilter, applyFilter }) => (
    <div className="cmn-filter__popoverFooter">
        <button
            className={`${btnCls} ${btnCls}_secondary`}
            onClick={cancelFilter}
        >
            Cancel
        </button>
        <button
            className={`${btnCls} ${btnCls}_primary`}
            onClick={applyFilter}
        >
            Apply
        </button>
    </div>
);

PopoverFooter.propTypes = {
    applyFilter: PropTypes.func.isRequired,
    cancelFilter: PropTypes.func.isRequired,
};

export default PopoverFooter;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/PopoverFooter.jsx